import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from './models/user';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  readonly apiUrl: string = 'https://platform.keyboardpro.com/lang/uk/kbp/_php';
  readonly proxyUrl_GET: string = '/assets/proxy/proxy_GET.php' // NOTE: should remove in every request the param 'request' -> only for proxy
  readonly proxyUrl_POST: string = '/assets/proxy/proxy_POST.php' // NOTE: should remove in every request the param 'request' -> only for proxy
  readonly proxyUrl_SITE: string = '/assets/proxy/proxy_site.php' // NOTE: should remove in every request the param 'request' -> only for proxy
  constructor(
    private http: HttpClient,
    private ngxXml2jsonService: NgxXml2jsonService) { }

  login(username: string, password: string): Observable<any> {
    const body = {
      usernameInput: username,
      passwordInput: password,
    }

    // only used for proxy
    const proxyBody = {
      lang: 'uk',
      params: body,
      endpoint: '/request.php'
    }
    
    //return this.http.post(`${this.apiUrl}/request.php`, body)
    return this.http.post(`${this.proxyUrl_POST}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
      
  }

  loadBookmarks(userId: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: '/requestBookmarkAdvancedLessons.php'
    }
    
    //return this.http.post(`${this.apiUrl}/requestBookmarkAdvancedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
      
  }

  loadCompletedLessons(userId: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: '/requestCompletedLessons.php'
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
      
  }

  saveUser(user: User, oldValue: {oldPass: string, oldEmail: string}): Observable<any> {
    const body = {
      usernameText: user.username,
      passwordText: user.password,
      fullnameNew: user.fullName,
      lang: user.language_in_use,
      old_pass: oldValue.oldPass,
      old_email: oldValue.oldEmail,
      next: user.keyboard_in_use
    }

    // only used for proxy
    const proxyBody = {
      lang: 'uk',
      params: body,
      endpoint: '/userUpdate.php'
    }

    return this.http.post(`${this.proxyUrl_SITE}`, proxyBody)
    .pipe(      
      tap(value => console.log(value))
    )
  }

  saveKeyboard(user: User): Observable<any> {
    const body = {
      usernameText: user.username,
      passwordText: user.password,
      fullnameNew: user.fullName,
      lang: user.language_in_use,      
      next: `${user.keyboard_in_use}`
    }

    // only used for proxy
    const proxyBody = {
      lang: 'uk',
      params: body,
      endpoint: '/userUpdate.php'
    }

    return this.http.post(`${this.proxyUrl_SITE}`, proxyBody)
    .pipe(      
      tap(value => console.log(value))
    )
  }


  // key target lesson letters
  loadKeyboardKeys(userId:number, keyboard_in_use: number, lang: string): Observable<any> {
    const body = {
      userId: userId,      
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/keys${keyboard_in_use}.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        value = value.replace('<character>&</character>', '<character>&amp;</character>');
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // keylessons loads
  // last access of lesson
  loadBookmarksForLesson(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestBookmarkForLesson${id}.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // key target lesson letters
  loadTargetLetters(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/practicedKeysBasicLessons${id}.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // load exercises lines for lessons
  loadLessonsExercises(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      encode: true,
      lang: lang,
      params: body,
      endpoint: `/Lesson${id}.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // load last max exercise
  loadBestExercise(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestLastBookmarkForLesson${id}.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // load videos by exercise
  loadExerciseVideos(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/Lesson${id}Videos.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

   // key target lesson letters
  loadAllowedLetters(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/allowedLettersBasicLessons${id}.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        value = value.replace('<letter>&</letter>', '<letter>&amp;</letter>')
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  sendResultsLesson(userId:number, lesson:number, totalKeyStrokes:number, totalErrors:number, timeUsed: string, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson,
      totalKeyStrokes: totalKeyStrokes,
      totalErrors: totalErrors,
      timeUsed: timeUsed,

      pbk1: '-',
      pbk2: '-',
      pbk3: '-',
      pbk4: '-',
      pbk1n: '-',
      pbk2n: '-',
      pbk3n: '-',
      pbk4n: '-'
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/sendResultsToDataBase.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log(value))
    )
  }

  markLessonCompleted(userId:number, lesson:number, lang: string){
    const body = {
      userId: userId,
      lesson: lesson      
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/markLessonComplete.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log(value))
    )
  }

  setBookmark(userId: number, id: number, exercise: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: id,
      exercise: exercise
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/setBookmark.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log('setBookmar', value))
    )
  }

  // Advancedlessons loads
  // last access of lesson
  loadBookmarksForAdvancedLesson(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestBookmarkForAdvancedLesson${id}.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // load exercises lines for lessons
  loadAdvancedLessonsExercises(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      encode: true,
      lang: lang,
      params: body,
      endpoint: `/AdvancedLesson${id}.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }
  
  // load last max exercise
  loadBestAdvancedExercise(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestLastBookmarkForLesson${id}Advanced.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // load last max exercise
  load5LastAdvancedResults(userId:number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: id
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/getLast5Results_Advanced.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  setBookmarkAdvanced(userId: number, id: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: id
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/setBookmarkAdvanced.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log('setBookmarkAdvanced', value))
    )
  }

  sendResultsAdvancedLesson(userId:number, lesson:number, totalKeyStrokes:number, totalErrors:number, timeUsed: string, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson,
      totalKeyStrokes: totalKeyStrokes,
      totalErrors: totalErrors,
      timeUsed: timeUsed,

      pbk1: '-',
      pbk2: '-',
      pbk3: '-',
      pbk4: '-',
      pbk1n: '-',
      pbk2n: '-',
      pbk3n: '-',
      pbk4n: '-'
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/sendResultsToDataBaseAdvanced.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log(value))
    )
  }

  markAdvancedLessonCompleted(userId:number, lesson:number, lang: string){
    const body = {
      userId: userId,
      lesson: lesson      
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/markAdvancedLessonComplete.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log(value))
    )
  }

  // key results
  loadLastResults(userId: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/updatePageTwoReturningUser.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  loadChartPie(userId: number, lesson: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestBasicLessonProgress.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  loadChartLine(userId: number, lesson: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/getLast5Results.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // Exam
  loadExamResults(userId: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestExamResultsForDiploma.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  // last exam
  loadExamLastAccess(userId: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestResultForFreeExam.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  loadExamExercises(userId:number, lang: string): Observable<any> {
    const body = {
      userId: userId,
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/ExamExercises.xml`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  sendResultsExam(userId:number, lesson:number, totalKeyStrokes:number, totalErrors:number, timeUsed: string, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson,
      totalKeyStrokes: totalKeyStrokes,
      totalErrors: totalErrors,
      timeUsed: timeUsed,

      pbk1: '-',
      pbk2: '-',
      pbk3: '-',
      pbk4: '-',
      pbk1n: '-',
      pbk2n: '-',
      pbk3n: '-',
      pbk4n: '-'
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/sendResultsToDataBaseExam.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(      
      tap(value => console.log(value))
    )
  }

  // Advanced Results
  loadAdvancedChartPie(userId: number, lesson: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/requestAdvancedLessonProgress.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

  loadAdvancedChartLine(userId: number, lesson: number, lang: string): Observable<any> {
    const body = {
      userId: userId,
      lesson: lesson
    }

    // only used for proxy
    const proxyBody = {
      lang: lang,
      params: body,
      endpoint: `/getLast5Results_Advanced.php`
    }
    
    //return this.http.post(`${this.apiUrl}/requestCompletedLessons.php`, body)
    return this.http.post(`${this.proxyUrl_GET}`, proxyBody, { responseType: 'text' })
    .pipe(
      map(value => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(value.replace(/^\s+|\s+$/g, ''), 'text/xml');
        return this.ngxXml2jsonService.xmlToJson(xml);
      }),
      tap(value => console.log(value))
    )
  }

}
